import { DashboardModule, Link } from '@domain-group/suit-theme'

import type { QuickLink } from '@modals/ManageEntityQuickLinksModal/hooks/useManageEntityQuickLinksModal'

import QuickLinkListItem from './QuickLinkListItem'

  interface CustomLinksProps {
   callbacks: {
    createOrEditCustomLinks: () => void,
   },
   hasQuickLinks: boolean,
   loading: boolean,
   quickLinks: QuickLink[],
  }

const CustomLinks = (props: CustomLinksProps) => {
  const {
    callbacks: {
      createOrEditCustomLinks,
    },
    hasQuickLinks,
    loading,
    quickLinks,
  } = props

  return (
    <DashboardModule
      loading={loading}
      headerRight={(
        <Link
          onClick={() => createOrEditCustomLinks()}
          textProps={{ fontSize: 'small' }}
        >
          Manage
        </Link>
      )}
      title="Custom Links"
    >
      <>
        {!hasQuickLinks && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Links Present.
            </DashboardModule.BlankState.Title>
          </DashboardModule.BlankState>
        )}

        {!loading && hasQuickLinks && (
          // @ts-expect-error TS2322
          <DashboardModule.ScrollableSection flexDirection="column">
            {quickLinks.map((quickLink: QuickLink) => (
              <QuickLinkListItem
                key={quickLink?.id}
                quickLink={quickLink}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}
      </>
    </DashboardModule>
  )
}

export default CustomLinks
